// CSS infinite marquee (transform-only, reduced-motion safe via global media query)
export function Marquee({ items = [], className = "", itemClassName = "", reverse = false }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`}>
      <div className="flex w-max marquee-track" style={reverse ? { animationDirection: "reverse" } : undefined}>
        {doubled.map((it, i) => (
          <span key={i} className={itemClassName}>{it}</span>
        ))}
      </div>
    </div>
  );
}
